import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { RssFeedBlock } from '../../_blocks/RssFeed/RssFeedBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type RssFeedWidget = ContextWidget<RssFeedBlock, WidgetType.rssfeed>;

export function RssFeedWidget(props: RssFeedWidget) {
  const { t } = useSonTranslation('RssFeed');
  return <DefaultContextWidget {...props} icon={Icons.RSS_FEED} title={t('widgetTitle')} />;
}
